'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var MapContext = require('./MapContext.js');

/*global google*/
var Marker = function (_a) {
    var children = _a.children, onClick = _a.onClick, position = _a.position, props = tslib.__rest(_a, ["children", "onClick", "position"]);
    var ctx = react.useContext(MapContext.default);
    var map = ctx.map;
    var isReady = ctx.isReady;
    var addMarker = ctx.addMarker;
    var lat = position.lat, lng = position.lng;
    var propsRef = react.useRef(props);
    react.useEffect(function () {
        var _a;
        var listeners = [];
        var marker;
        if (isReady) {
            var additionalProps = (_a = propsRef.current) !== null && _a !== void 0 ? _a : {};
            var newPosition = { lat: lat, lng: lng };
            marker = new google.maps.Marker(tslib.__assign({ map: map, position: newPosition }, additionalProps));
            addMarker(marker);
            if (onClick) {
                var clickListener = marker.addListener('click', function () {
                    return onClick(map, marker);
                });
                listeners.push(clickListener);
            }
        }
        return function () {
            if (listeners.length > 0) {
                listeners.map(function (listener) { return google.maps.event.removeListener(listener); });
            }
            marker === null || marker === void 0 ? void 0 : marker.setMap(null);
        };
    }, [isReady, addMarker, onClick, map, lat, lng]);
    return jsxRuntime.jsx(jsxRuntime.Fragment, { children: children });
};
var Marker$1 = Marker;

exports.default = Marker$1;
//# sourceMappingURL=Marker.js.map
